import { User, UserManager } from 'oidc-client';
import React, { useEffect, useRef, ReactElement } from 'react';
import { authActions } from '../reducers/authReducer/authSlice';
import jwt_decode from 'jwt-decode';
import { signoutAsync } from '../pages/SignoutOidc/SignoutOidc.component';

interface AssessmentSessionTokenInfo {
  assessmentSessionId: number
  isChairman: boolean
}
export default function AuthProvider({ userManager: manager, store, children }: any): ReactElement {
  const userManager = useRef<UserManager>();

  useEffect(() => {
    userManager.current = manager;
    const onUserLoaded = (user: User) => {
      const date = new Date();
      store.dispatch(authActions.storeUserAndSetAuthHeader(user));
      console.log('Token generated ' + date.toISOString());
    };

    const onUserUnloaded = () => {
      console.log(`user unloaded`);
    };

    const storeUser = async (userManager: UserManager, assessmentSessionId: number | null, asExaminer: boolean) => {
      const newUser = await userManager.signinSilent({assessmentSessionId: assessmentSessionId, asExaminer: asExaminer});
      userManager.storeUser(newUser);
      return authActions.storeUserAndSetAuthHeader(newUser);
    }

    const onAccessTokenExpiring = async () => {
      try {
        if (userManager.current !== undefined) {
          const user = await userManager.current.getUser();
          if (user !== null) {
            const jwt: AssessmentSessionTokenInfo = jwt_decode(user.access_token)
            if (jwt?.assessmentSessionId != null) {
              return await storeUser(userManager.current, jwt.assessmentSessionId, jwt.isChairman ? true : false);
            }
            return await storeUser(userManager.current, null, false);
          }
        }
        const date = new Date();
        console.log('user token expiring ' + date.toISOString());
      }
      catch (e) {
        console.error(`User not found: ${e}`);
        authActions.storeUserError();
      }
    };

    const onAccessTokenExpired = () => {
      const date = new Date();
      console.log('user token expiring ' + date.toISOString());
      signoutAsync();
    };

    const onUserSignedOut = () => {
      signoutAsync();
    };

    // events for user
    //@ts-ignore
    userManager.current.events.addUserLoaded(onUserLoaded);
    //@ts-ignore
    userManager.current.events.addUserUnloaded(onUserUnloaded);
    //@ts-ignore
    userManager.current.events.addAccessTokenExpiring(onAccessTokenExpiring);
    //@ts-ignore
    userManager.current.events.addAccessTokenExpired(onAccessTokenExpired);
    //@ts-ignore
    userManager.current.events.addUserSignedOut(onUserSignedOut);

    // Specify how to clean up after this effect:
    return function cleanup() {
      //@ts-ignore
      userManager.current.events.removeUserLoaded(onUserLoaded);
      //@ts-ignore
      userManager.current.events.removeUserUnloaded(onUserUnloaded);
      //@ts-ignore
      userManager.current.events.removeAccessTokenExpiring(onAccessTokenExpiring);
      //@ts-ignore
      userManager.current.events.removeAccessTokenExpired(onAccessTokenExpired);
      //@ts-ignore
      userManager.current.events.removeUserSignedOut(onUserSignedOut);
    };
  }, [userManager, manager, store]);

  return React.Children.only(children);
}


